var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { RETURN_SUMMARY_SESSION_STORAGE_KEY } from '../constants/general';
import { isCookieEnabled } from './cookie-helper';
import { getWindow } from './general';
export var getFromStorage = function (name) { return __awaiter(void 0, void 0, void 0, function () {
    var readOrderDetailsFromClipboard, clipboardText, parsedText, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                readOrderDetailsFromClipboard = isCookieEnabled('useClipboard');
                if (!readOrderDetailsFromClipboard) return [3 /*break*/, 4];
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, navigator.clipboard.readText()];
            case 2:
                clipboardText = _a.sent();
                parsedText = JSON.parse(clipboardText);
                return [2 /*return*/, JSON.stringify(parsedText)];
            case 3:
                error_1 = _a.sent();
                // eslint-disable-next-line no-console
                console.error('Failed to parse clipboard:', error_1);
                return [2 /*return*/, ''];
            case 4: 
            // normal flow
            return [2 /*return*/, sessionStorage.getItem(name)];
        }
    });
}); };
/**
 * Sets the value in the session storage with the specified key.
 * @param key - The key to set in the session storage.
 * @param value - The value to be stored in the session storage.
 */
export var setSessionStorage = function (key, value) {
    var _a;
    var objectJsonString = JSON.stringify(value);
    (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.sessionStorage.setItem(key, objectJsonString);
};
export var disableAbandonmentSurvey = function () {
    var _a, _b;
    (_a = window.sessionStorage) === null || _a === void 0 ? void 0 : _a.setItem('displayReturnAbandonSurvey', 'false');
    (_b = window.sessionStorage) === null || _b === void 0 ? void 0 : _b.setItem('displayLORPAbandonSurvey', 'false');
};
export var enableReturnAbandonmentSurvey = function () {
    var _a, _b;
    (_a = window.sessionStorage) === null || _a === void 0 ? void 0 : _a.setItem('displayReturnAbandonSurvey', 'true');
    (_b = window.sessionStorage) === null || _b === void 0 ? void 0 : _b.setItem('displayLORPAbandonSurvey', 'false');
};
export var enableLORPAbandonmentSurvey = function () {
    var _a, _b;
    (_a = window.sessionStorage) === null || _a === void 0 ? void 0 : _a.setItem('displayReturnAbandonSurvey', 'false');
    (_b = window.sessionStorage) === null || _b === void 0 ? void 0 : _b.setItem('displayLORPAbandonSurvey', 'true');
};
/**
 * Retrieves the return summary fields from the session storage.
 * If any of the required fields are missing, it redirects to the purchase history page.
 * @returns An object containing the orderId, emailId, returnItems, and returnTrackingNumbers.
 *          Returns undefined and redirects if any of the required fields are missing.
 */
export var getReturnSummaryFieldsFromStorage = function () { return __awaiter(void 0, void 0, void 0, function () {
    var returnSummaryStorageData, parsedReturnSummaryObject, selectedReturnItems, returnTrackingNumbers, returnByDate, trackingDetails, emailId, orderId, refundValues, returnMethod, sorisId, sorisQRCode, isMultiAddressReturn, multipleReturnBoxes, shipments;
    return __generator(this, function (_a) {
        returnSummaryStorageData = sessionStorage.getItem(RETURN_SUMMARY_SESSION_STORAGE_KEY);
        parsedReturnSummaryObject = JSON.parse(returnSummaryStorageData || '{}');
        selectedReturnItems = parsedReturnSummaryObject.selectedReturnItems, returnTrackingNumbers = parsedReturnSummaryObject.returnTrackingNumbers, returnByDate = parsedReturnSummaryObject.returnByDate, trackingDetails = parsedReturnSummaryObject.trackingDetails, emailId = parsedReturnSummaryObject.emailId, orderId = parsedReturnSummaryObject.orderId, refundValues = parsedReturnSummaryObject.refundValues, returnMethod = parsedReturnSummaryObject.returnMethod, sorisId = parsedReturnSummaryObject.sorisId, sorisQRCode = parsedReturnSummaryObject.sorisQRCode, isMultiAddressReturn = parsedReturnSummaryObject.isMultiAddressReturn, multipleReturnBoxes = parsedReturnSummaryObject.multipleReturnBoxes, shipments = parsedReturnSummaryObject.shipments;
        // NOTE: for cash n carry, if they ever get allowed, we need to allow for no emailId.
        if (!orderId || !emailId || !selectedReturnItems || !returnMethod) {
            // Redirect to purchase history if any of the required fields are missing
            // returnByDate can be 'optional' for now as an empty string if not found in case BED doesnt pass value by the time this goes in
            window.location.replace("/myaccount/purchase-history");
            return [2 /*return*/, undefined];
        }
        return [2 /*return*/, {
                orderId: orderId,
                emailId: emailId,
                selectedReturnItems: selectedReturnItems,
                returnTrackingNumbers: returnTrackingNumbers,
                returnByDate: returnByDate,
                trackingDetails: trackingDetails,
                refundValues: refundValues,
                returnMethod: returnMethod,
                sorisId: sorisId,
                sorisQRCode: sorisQRCode,
                isMultiAddressReturn: isMultiAddressReturn,
                multipleReturnBoxes: multipleReturnBoxes,
                shipments: shipments,
            }];
    });
}); };
